


























































































import Vue from 'vue'
import { PropValidator } from 'vue/types/options'  // using "as () => T" seems enough
import { IDevice, IVW } from '@/types/model'
import { setInterval } from 'timers'
import { getVwTxColor, getVwScreenColor, getVwTxFromVwRx, getVwPosFromRx, vw_color_t, geometry_t, vwMoveTxTo, vwResizeTxTo, vwResizeTxToward, four_ways_direction_t, vwMoveTxToward, vwRxHasBezelSet } from '@/vw_algorithm'
import { thumb_size_t } from '@/store/modules/pref'
import { geometry_size_t, screen_style_t, tx_area_style_t } from '@/vw_algorithm'
import { $COLOR, rotateFlipToIgClass, deepCopy } from '@/utils'
import { ApiVwTx, ApiVwRx, OsdConfig, ApiVwBezel, RotateFlip } from '@/types/api'
import { window } from 'rxjs/operators'
import IgIcon from '@/components/IgIcon.vue'
import OsdSelector from '@/components/dialogs/OsdSelector.vue'
import ArrowPad from '@/components/ArrowPad.vue'
import BezelDialog from '@/components/dialogs/Bezel.vue'
import RotateFlipDialog from '@/components/dialogs/RotateFlip.vue'
import easyapi, { showSnackbar } from '@/easyapi'
import { QueryManipulator } from '@/router'
import { getDevName } from '@/store/modules/device'

type vw_editor_t = 'rxMapper' | 'txMapper'

interface drag_icon_style {
  mover: string
  resizer: string
}

type drag_icon_t = 'mover' | 'resizer' | ''
type dragging_what_t = drag_icon_t | 'txRow' | 'rxRow'


const DRAGGABLE_ICON_SIZE = 40

export default Vue.extend({
  components: {
    ArrowPad,
    IgIcon,
    BezelDialog,
    RotateFlipDialog,
    OsdSelector,
  },
  model: {
    prop: 'device'
  },
  props: {
    role: {
    } as PropValidator<vw_editor_t>,
    copiedVw: {
      type: Object
    } as PropValidator<IVW>,
    /** RxDragRow */
    draggingRx: { } as PropValidator<IDevice|null>,
    /** RxDragRow */
    hoveringRx: { } as PropValidator<IDevice|null>,
    /** TxDragRow */
    draggingTx: { } as PropValidator<IDevice|null>,
    /** TxDragRow */
    hoveringTx: { } as PropValidator<IDevice|null>,
    thumbSize: {
      type: String,
      default: 'md'
    } as PropValidator<thumb_size_t>,
    /**
     * width and height has higher priority than thumbSize.
     * Don't specify width and height simultaneously.
     */
    width: {
      type: Number,
      default: 0
    },
    /**
     *  width and height has higher priority than thumbSize
     * Don't specify width and height simultaneously.
     */
    height: {
      type: Number ,
      defualt: 0
    },
    showTxName: {
      type: Boolean,
      default: false
    },
  },
  data (): {
    /** When mouse is dragging a RxDragRow over a screen (without drop),
     * this variable will be assign to the displayIndex of screen
     */
    theRxDisplayIndexMouseDraggingAt: number,  // FIXME: Remove this?
    mouseCount: number,
    /** Only used when being used as TxMapper */
    selectedTx: ApiVwTx | null,
    selectedRxs: ApiVwRx[],
    draggingIconType: drag_icon_t,
    showBezelDialog: boolean,
    showRotateFlipDialog: boolean,
  } {
    return {
      theRxDisplayIndexMouseDraggingAt: -1,
      mouseCount: 0,
      selectedTx: null,
      selectedRxs: [],
      draggingIconType: '',
      showBezelDialog: false,
      showRotateFlipDialog: false,
    }
  },
  computed: {
    selectIconSize (): number { return Math.max(24, this.screenSize.height * 0.3) },
    draggingWhat (): dragging_what_t {
      if (this.draggingTx) { return 'txRow' }
      if (this.draggingRx) { return 'rxRow' }
      return this.draggingIconType
    },
    showCropIcon (): boolean { return this.screenSize.height > 55 },
    columns (): number { return this.copiedVw.layout.columns },
    rows (): number { return this.copiedVw.layout.rows },
    showIndexes (): boolean { return true },
    showTxMenu (): boolean { return !!this.selectedTx },
    showRxMenu (): boolean { return this.selectedRxs.length !== 0 && !this.showBezelDialog },
    canSetOsd (): boolean {
      if (this.selectedRxs.length !== 1) {
        return false
      }
      return this.copiedVw.vendor === 'Aspeed'
    },
    showDragInstruction (): boolean {
      if (this.role === 'rxMapper') {
        return this.mouseCount === 0 && !!this.draggingRx
      } else {
        return this.mouseCount === 0 && !!this.draggingTx
      }
    },
    nameOfSelectedTx (): string {
      if (this.selectedTx) {
        const mac = this.selectedTx.mac
        const dev = this.$state.device.list.find(x => x.mac === mac)
        if (!dev) {console.error('[To Developer] Impossible'); return ''}
        return this.dn(dev)
      }
      return ''
    },
    rootSize (): geometry_size_t {
      if (this.width) {
        return { width: this.width, height: this.width * 5 / 9 }
      } else if (this.height) {
        return { width: this.height * 9 / 5, height: this.height }
      } else {
        let w = 0
        switch (this.thumbSize) {
          case 'xs': w = 40; break
          case 'sm': w = 90; break
          case 'md': w = 110; break
          case 'lg': w = 170; break
          case 'xl': w = 240; break
        }
        return { width: w, height: w * 5 / 9 }
      }
    },
    rootStyle (): string {
      return `width:${this.rootSize.width}px;height:${this.rootSize.height}px;`
    },
    screensContainerSize (): geometry_size_t {
      return {
        width: this.screenSize.width * this.columns,
        height: this.screenSize.height * this.rows
      }
    },
    screensContainerStyle (): string {
      return `width:${this.screensContainerSize.width}px;height:${this.screensContainerSize.height}px;`
    },
    screenSize (): geometry_size_t {
      if (this.columns > this.rows) {
        const w = this.rootSize.width / this.columns
        const h = w * 5 / 9
        return { width: w, height: h }
      } else {
        const h = this.rootSize.height / this.rows
        const w = h * 9 / 5
        return { width: w, height: h }
      }
    },
    screenCommonStyle (): string {
      return `width:${this.screenSize.width}px;height:${this.screenSize.height}px;`
    },
    screenList (): screen_style_t[] {
      if (this.role === 'rxMapper') {
        return this.copiedVw.rxList.map((rx) => {
          const tmp: screen_style_t = {
            displayIndex: rx.displayIndex,
            style: this.screenCommonStyle,
            clickable: false,
            hasBezelSet: vwRxHasBezelSet(rx),
            rxSelected: false,
            osd: rx.osd
          }
          if (this.draggingRx) {
            // 1. RxDragRow is dragging
            if (rx.mac) {
              tmp.style += `background-color: ${$COLOR.PRIMARY};`
              tmp.clickable = true
            }
            if (this.theRxDisplayIndexMouseDraggingAt === rx.displayIndex && this.mouseCount === 1) {
              tmp.style += `background-color: ${$COLOR.PRIMARY};`
              tmp.clickable = true
            }
          } else {
            // 2. No Rx is dragging
            if (rx.mac) {
              tmp.style += `background-color: ${$COLOR.PRIMARY};`
              tmp.clickable = true
            }
            // Hovering on RxDragRow
            if ((this.hoveringRx && this.hoveringRx.mac === rx.mac) ||
                (this.selectedRxs.length !== 0 && this.selectedRxs.some(selRx => selRx.displayIndex === rx.displayIndex))) {
                  tmp.rxSelected = true
                }
          }
          return tmp
        })
      } else {
        // TX Mapper
        return this.copiedVw.rxList.map((rx) => {
          const tmp: screen_style_t = {
            displayIndex: rx.displayIndex,
            style: this.screenCommonStyle,
            clickable: false,
            hasBezelSet: false,
            rxSelected: false,
            osd: 0
          }
          if (this.draggingWhat === 'txRow') {
            if (rx.mac === '') { tmp.style += 'opacity: 0.5;' }
            if (this.theRxDisplayIndexMouseDraggingAt === rx.displayIndex && this.mouseCount === 1) {
              tmp.style += `background-color: ${$COLOR.PRIMARY};`
              tmp.clickable = true
            }
          } else {
            // No TX is dragging || dragging resizer || dragging mover
            const tx = getVwTxFromVwRx(rx, this.copiedVw)
            if (rx.mac === '') { tmp.style += 'opacity: 0.5;' }
            if (tx) {
              let clr: vw_color_t
              if (tx === this.selectedTx) {
                clr = { bg: $COLOR.PRIMARY, bd: $COLOR.PRIMARY }
              } else {
                clr = getVwTxColor(tx.mac, this.copiedVw)
              }
              if (clr) {
                tmp.style += `background-color: ${clr.bg};`
                tmp.clickable = true
              }
              if ((this.selectedTx && this.selectedTx.mac !== tx.mac) ||
              (this.hoveringTx && this.hoveringTx.mac !== tx.mac)) {
                tmp.style += 'opacity: 0.3;'
              }
            }
          }
          return tmp
        })
      }
    },
    txAreaList (): tx_area_style_t[] {
      const fin: tx_area_style_t[] = []
      for (const txArea of this.copiedVw.txList) {
        const geometry: geometry_t = {
          x: txArea.column * this.screenSize.width,
          y: txArea.row * this.screenSize.height,
          width: txArea.columns * this.screenSize.width,
          height: txArea.rows * this.screenSize.height
        }
        let style = `left: ${geometry.x}px;` +
                    `top:  ${geometry.y}px;` +
                    `width:  ${geometry.width}px;` +
                    `height: ${geometry.height}px;`
        if (this.selectedTx) {
          if (this.selectedTx.mac !== txArea.mac) {
            style += 'opacity: 0.3;'
            const vc = getVwTxColor(txArea.mac, this.copiedVw)
            style += `border: 5px solid ${vc.bd};`
          }
        } else {
          const vc = getVwTxColor(txArea.mac, this.copiedVw)
          style += `border: 5px solid ${vc.bd};`
        }
        fin.push({
          style, geometry,
          mac: txArea.mac,
          name: getDevName(txArea.mac),
          rotateFlipClass: rotateFlipToIgClass(txArea.rotateFlip)
        })  // TODO: TX name
      }
      console.log(`vw-${this.copiedVw.id} areas`, fin)
      return fin
    },
    showDragIcon (): boolean {
      return this.screenSize.width >= DRAGGABLE_ICON_SIZE * 1.8
    },
    dragIconStyle (): drag_icon_style {
      if (!this.selectedTx || !this.showDragIcon) { return { mover: 'display: none;', resizer: 'display: none;' } }
      const selectedMac = this.selectedTx.mac
      const txArea = this.txAreaList.find(x => x.mac === selectedMac)
      if (!txArea) { console.error('[To Developer] Impossible.'); throw new Error('WTF') }
      const txGeo: geometry_t = txArea.geometry
      const i = DRAGGABLE_ICON_SIZE
      const d = 5
      return {
        mover:   `left: ${txGeo.x - d}px; top: ${txGeo.y - d}px;`,
        resizer: `left: ${txGeo.x + txGeo.width - i + d}px; top: ${txGeo.y + txGeo.height - i + d}px;`
      }
    },
  },
  methods: {
    preview () {
      if (!this.copiedVw) {return}
      const tmp = deepCopy(this.copiedVw)
      tmp.displayIndex = true
      console.table(tmp.rxList)
      easyapi.vwPreviewStart(tmp)
    },
    clickScreen (ev: MouseEvent, screen: screen_style_t) {
      if (this.role === 'txMapper') {
        const existedRx = this.copiedVw.rxList.find(r => r.displayIndex === screen.displayIndex)
        if (!existedRx) { throw new Error('[To Developer] This should not happened. Type of rxList is ApiVwRx[]') }
        const clickedTx = getVwTxFromVwRx(existedRx, this.copiedVw)
        if (!clickedTx && !this.selectedTx) {
          showSnackbar(this.$t('vw.dragTxPlease_help'), 'info')
          this.$emit('needDraggerHint')
        }
        if (this.selectedTx === clickedTx) {
          this.selectedTx = null
        } else {
          this.selectedTx = clickedTx
        }
      } else if (this.role === 'rxMapper') {
        const clickedRx = this.copiedVw.rxList.find(r => r.displayIndex === screen.displayIndex) || null
        if (!clickedRx) { throw new Error('[To Developer] Impossible') }
        if (clickedRx.mac === '') {
          showSnackbar(this.$t('vw.dragRxPlease_help'), 'info')
          this.$emit('needDraggerHint')
        }
        if (this.selectedRxs.includes(clickedRx)) {
          this.selectedRxs = this.selectedRxs.filter(x => x !== clickedRx)
        } else {
          this.selectedRxs.push(clickedRx)
        }
      }
    },
    removeSelectedTx () {
      if (!this.selectedTx) { console.error('[To Developer] Impossible'); return}
      const i = this.copiedVw.txList.indexOf(this.selectedTx)
      this.copiedVw.txList.splice(i, 1)
      this.selectedTx = null
    },
    removeSelectedRxs () {
      for (const rx of this.selectedRxs) {
        rx.mac = ''
      }
      this.selectedRxs.splice(0)
    },
    pressResizerPad (direction: four_ways_direction_t) {
      if (!this.selectedTx) {console.error('[To Developer] Impossible.'); return}
      vwResizeTxToward(this.copiedVw, this.selectedTx.mac, direction)
    },
    pressMoverPad (direction: four_ways_direction_t) {
      if (!this.selectedTx) {console.error('[To Developer] Impossible.'); return}
      vwMoveTxToward(this.copiedVw, this.selectedTx.mac, direction)
    },
    dragEnter (ev: DragEvent, screen: screen_style_t) {
      this.mouseCount++
      ev.preventDefault() // IMPORTANT: "Always handle dragenter-event on possible dropzones if the drop is allowed by calling event.preventDefault().""
      if (this.draggingRx || this.draggingTx || this.draggingWhat !== '') {
        this.theRxDisplayIndexMouseDraggingAt = screen.displayIndex
      }
      if (this.draggingWhat === 'mover') {
        if (!this.selectedTx) { console.error('[To Developer] This should never happened.'); return false }
        vwMoveTxTo(this.copiedVw, this.selectedTx.mac, screen.displayIndex)
        // this.preview()  // TODO unneeded?
      } else if (this.draggingWhat === 'resizer') {
        if (!this.selectedTx) { console.error('[To Developer] This should never happened.'); return false }
        vwResizeTxTo(this.copiedVw, this.selectedTx.mac, screen.displayIndex)
        // this.preview() // TODO: unneeded?
      }
    },
    dragOver (ev: DragEvent) {
      // Make leave and drop work
      ev.stopPropagation()
      ev.preventDefault()
    },
    drop (ev: DragEvent, droppedOnScreen: screen_style_t) {
      this.mouseCount--
      if (this.role === 'rxMapper') {
        if (this.draggingRx) {
          this.theRxDisplayIndexMouseDraggingAt = -1
          // Remove existing RX MAC if duplicated with draggingDev
          const mac = this.draggingRx.mac
          const existedRx = this.copiedVw.rxList.find(r => r.mac === mac)
          if (existedRx) { existedRx.mac = '' }
          const rx = this.copiedVw.rxList.find(r => r.displayIndex === droppedOnScreen.displayIndex)
          if (!rx) { console.error('[To Developer] impossible'); return }
          rx.mac = this.draggingRx.mac
        }
      } else {
        if (this.draggingTx) {
          // Remove existing TX if duplicated with draggingDev
          const draggingTxMac = this.draggingTx.mac
          const rxObj = this.copiedVw.rxList.find(r => r.displayIndex === droppedOnScreen.displayIndex)
          if (!rxObj) { console.error('[To Developer] This should never happen.'); return }
          const overlappedTx = getVwTxFromVwRx(rxObj, this.copiedVw)
          if (overlappedTx) {
            // exchange TX if existed
            const overlappedTxOriginalMac = overlappedTx.mac
            const ifDraggingTxHasBeenAllocated = this.copiedVw.txList.find(x => x.mac === draggingTxMac)  // if the dragging TX has already been allocated in txList of this VW
            if (ifDraggingTxHasBeenAllocated) {
              if (draggingTxMac === overlappedTxOriginalMac) {
                // do nothing
              } else {
                // exchange
                ifDraggingTxHasBeenAllocated.mac = overlappedTxOriginalMac
                overlappedTx.mac = draggingTxMac
              }
            } else {
              overlappedTx.mac = draggingTxMac
            }
            this.preview()
            return
          }
          const indexOfExistedTx = this.copiedVw.txList.findIndex(x => x.mac === draggingTxMac)
          if (indexOfExistedTx !== -1) {
            this.copiedVw.txList.splice(indexOfExistedTx, 1)
          }
          const screenPos = getVwPosFromRx(rxObj, this.copiedVw)
          this.copiedVw.txList.push({
            mac: this.draggingTx.mac,
            row: screenPos.row,
            column: screenPos.column,
            rows: 1,
            columns: 1,
            rotateFlip: RotateFlip.normal
          })
          /// draggingTx ends here
        }
      }
      this.preview()
    },
    dragLeaveRoot () {
      this.mouseCount--
    },
    moverDragStart (ev: DragEvent) {
      this.draggingIconType = 'mover'
      ev.dataTransfer.setData('text/unusedThough', 'For Firefox + draggable polyfill, this is required.')
      const elem = document.createElement('div')
      ev.dataTransfer.setDragImage(elem, 0, 0)

    },
    moverDragEnd () {
      this.draggingIconType = ''
      this.preview()
    },
    resizerDragStart (ev: DragEvent) {
      this.draggingIconType = 'resizer'
      ev.dataTransfer.setData('text/unusedThough', 'For Firefox + draggable polyfill, this is required.')
      const elem = document.createElement('div')
      ev.dataTransfer.setDragImage(elem, 0, 0)
    },
    resizerDragEnd () {
      this.draggingIconType = ''
      this.preview()
    },
    openBezelDialog () { QueryManipulator.add('bezel', 'true') },
    openRotateFlipDialog () { QueryManipulator.add('rotate_flip', 'true') },
    setSelectedTxRotateFlip () { QueryManipulator.add('bezel', 'true') },
    setSelectedRxOsd () {
      const currOsdId = this.selectedRxs[0].osd || 0
      this.$router.push({ name: 'vwlst_details_rxmap_osd', query: { selected_osd_id: currOsdId + '' } })
    },
    assignBezel (applyData: ApiVwBezel) {
      for (const rx of this.selectedRxs) {
        Object.assign(rx.bezel, applyData)
      }
      this.selectedRxs.splice(0)
    },
    assignRotateFlip (nv: RotateFlip) {
      if (!this.selectedTx) { return }
      this.selectedTx.rotateFlip = nv
      this.preview()
    },
    onOsdSelect (osdid: number) {
      console.log('成功摳到 onOsdSelect', osdid)
      this.selectedRxs[0].osd = osdid
    },
  },
  watch: {
    '$route.query' () {
      this.showRotateFlipDialog = !!QueryManipulator.get('rotate_flip')   // Vue mounts child component first, so if put this mechanism in child, child component shows first (?)
      this.showBezelDialog = !!QueryManipulator.get('bezel')   // Vue mounts child component first, so if put this mechanism in child, child component shows first (?)
    }
  },
  mounted () {
    QueryManipulator.delMultiple('rotate_flip', 'bezel')
    if (!this.role) { console.error('[To Developer] role is required') }
    if (!this.copiedVw) { console.error('[To Developer] copiedVw is required') }
    if (this.role === 'rxMapper') {
      if (this.draggingRx === undefined) { console.error('[To Developer] draggingRx is required for rxMapper') }
      if (this.hoveringRx === undefined) { console.error('[To Developer] hoveringRx is required for rxMapper') }
    } else {
      if (this.draggingTx === undefined) { console.error('[To Developer] draggingTx is required for txMapper') }
      if (this.hoveringTx === undefined) { console.error('[To Developer] hoveringTx is required for txMapper') }
    }
    this.preview()
  },
})
